module.exports = __webpack_public_path__ + "static/media/bro.c306ed8d.png";